// import classNames from 'classnames';
import {
  Button,
  ForwardIcon,
  IError,
  List,
  ListItem,
  LoadingOverlay,
  Vendors,
  useToast,
} from '@comptia-sso/core';
import { MouseEvent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

// Config.
import { env } from 'config';

// Hooks.
import {
  useProfile,
  useRedirectToVendor,
  useTrackEvent,
  useTrackOdpEvent,
} from 'hooks';
import { useSierra } from '../../app/SierraContext';

// Styles.
import styles from 'views/HomeView/HomeView.module.scss';
import { Navigate, useNavigate } from 'react-router-dom';

export const PearsonVueDashboard = (): ReactElement => {
  const sierra = useSierra();
  const { t } = useTranslation();
  const [popToast] = useToast();
  const [profile] = useProfile();
  const [redirectToVendor, { isLoading: isRedirecting }] = useRedirectToVendor(
    profile?.id,
  );
  const trackEvent = useTrackEvent('Manage Your Exams');
  const trackOdpEvent = useTrackOdpEvent();
  const navigate = useNavigate();

  const handleEvent = (target: HTMLElement, eventName: string) => {
    trackOdpEvent('navigation', 'Launchpad Button', eventName);
    trackEvent('Clicked', { label: target.innerText });
  };

  return (
    <>
      <div className={styles.card}>
        <div className={styles.content}>
          <h2>{t('PearsonVueDashboard.Title')}</h2>
          <p>{t('PearsonVueDashboard.Content')}</p>
          {env.FLAG_PEARSON_ENABLED && !profile?.isBlocked ? (
            <Button
              className={styles.forwardButton}
              onClick={async (e) => {
                if (sierra.isEnabled()) {
                  sierra.navigateToSierraRoute('exams');
                } else {
                  handleEvent(e.target as HTMLElement, 'Manage Exam');

                  try {
                    profile?.externalIds?.pearsonVue &&
                    env.FLAG_PEARSON_DIRECTSSO_ENABLED
                      ? redirectToVendor(Vendors.PearsonVue)
                      : navigate('/profile/pearson', { replace: true });
                  } catch (error) {
                    popToast(
                      (error as IError)?.message || t('Toast.Error.Default'),
                    );
                  }
                }
              }}
            >
              {t('PearsonVueDashboard.Button')}&nbsp;
              <ForwardIcon />
            </Button>
          ) : (
            <p
              className={styles.blocked}
              dangerouslySetInnerHTML={{
                __html: t('ExamRegistration.Blocked'),
              }}
            />
          )}
          {(!profile?.externalIds?.pearsonVue || !env.FLAG_PEARSON_ENABLED) && (
            <Button
              className={styles.forwardButton}
              onClick={(e) => {
                handleEvent(e.target as HTMLElement, 'Testing Options');
              }}
              link
              to="https://www.comptia.org/testing/testing-options/about-testing-options"
            >
              {t('PearsonVueDashboard.Button-2')}&nbsp;
              <ForwardIcon />
            </Button>
          )}
          <Button
            className={styles.forwardButton}
            link
            onClick={(e) =>
              handleEvent(e.target as HTMLElement, 'Request Accomodations')
            }
            to={t('ExamRegistration.AccommodationsUrl')}
          >
            {t('PearsonVueDashboard.Button-3')}&nbsp;
            <ForwardIcon />
          </Button>
        </div>
      </div>
      <LoadingOverlay isOpen={isRedirecting} text={t('Loading.Default')} />
    </>
  );
};
